<script setup lang="ts">
const props = defineProps(['title'])
</script>

<template>
  <el-card shadow="never">
    <div class="card__body">
      <h4>{{ props.title }}</h4>
      <slot></slot>
    </div>
  </el-card>
</template>

<style lang="scss" scoped>
.el-card {
  width: 548px;
}

.card {
  &__body {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-spacing-lg);
  }
}
</style>
